// Login.js
import React, { useState, useRef, useEffect, useContext } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Select,
  MenuItem,
  InputAdornment,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import api from "../../api/axios";
import { useNavigate, useLocation } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import { subscribeToPush } from "../../utils/pushNotification";
import "./Login.css";

export default function Login() {
  const [input, setInput] = useState("");
  const [password, setPassword] = useState("");
  const [step, setStep] = useState("IDENTIFIER"); // IDENTIFIER | PASSWORD
  const [openRolePopup, setOpenRolePopup] = useState(false);
  const [inputError, setInputError] = useState("");
  const [countryCode, setCountryCode] = useState("+91");
  const countryCodes = [
    { code: "+1", label: "US / CA (+1)" },
    { code: "+7", label: "RU (+7)" },
    { code: "+20", label: "EG (+20)" },
    { code: "+27", label: "ZA (+27)" },
    { code: "+30", label: "GR (+30)" },
    { code: "+31", label: "NL (+31)" },
    { code: "+32", label: "BE (+32)" },
    { code: "+33", label: "FR (+33)" },
    { code: "+34", label: "ES (+34)" },
    { code: "+36", label: "HU (+36)" },
    { code: "+39", label: "IT (+39)" },
    { code: "+40", label: "RO (+40)" },
    { code: "+41", label: "CH (+41)" },
    { code: "+43", label: "AT (+43)" },
    { code: "+44", label: "GB (+44)" },
    { code: "+45", label: "DK (+45)" },
    { code: "+46", label: "SE (+46)" },
    { code: "+47", label: "NO (+47)" },
    { code: "+48", label: "PL (+48)" },
    { code: "+49", label: "DE (+49)" },
    { code: "+51", label: "PE (+51)" },
    { code: "+52", label: "MX (+52)" },
    { code: "+53", label: "CU (+53)" },
    { code: "+54", label: "AR (+54)" },
    { code: "+55", label: "BR (+55)" },
    { code: "+56", label: "CL (+56)" },
    { code: "+57", label: "CO (+57)" },
    { code: "+58", label: "VE (+58)" },
    { code: "+60", label: "MY (+60)" },
    { code: "+61", label: "AU (+61)" },
    { code: "+62", label: "ID (+62)" },
    { code: "+63", label: "PH (+63)" },
    { code: "+64", label: "NZ (+64)" },
    { code: "+65", label: "SG (+65)" },
    { code: "+66", label: "TH (+66)" },
    { code: "+81", label: "JP (+81)" },
    { code: "+82", label: "KR (+82)" },
    { code: "+84", label: "VN (+84)" },
    { code: "+86", label: "CN (+86)" },
    { code: "+90", label: "TR (+90)" },
    { code: "+91", label: "IN (+91)" },
    { code: "+92", label: "PK (+92)" },
    { code: "+93", label: "AF (+93)" },
    { code: "+94", label: "LK (+94)" },
    { code: "+95", label: "MM (+95)" },
    { code: "+98", label: "IR (+98)" },
    { code: "+212", label: "MA (+212)" },
    { code: "+213", label: "DZ (+213)" },
    { code: "+216", label: "TN (+216)" },
    { code: "+218", label: "LY (+218)" },
    { code: "+220", label: "GM (+220)" },
    { code: "+221", label: "SN (+221)" },
    { code: "+222", label: "MR (+222)" },
    { code: "+223", label: "ML (+223)" },
    { code: "+224", label: "GN (+224)" },
    { code: "+225", label: "CI (+225)" },
    { code: "+226", label: "BF (+226)" },
    { code: "+227", label: "NE (+227)" },
    { code: "+228", label: "TG (+228)" },
    { code: "+229", label: "BJ (+229)" },
    { code: "+230", label: "MU (+230)" },
    { code: "+231", label: "LR (+231)" },
    { code: "+232", label: "SL (+232)" },
    { code: "+233", label: "GH (+233)" },
    { code: "+234", label: "NG (+234)" },
    { code: "+235", label: "TD (+235)" },
    { code: "+236", label: "CF (+236)" },
    { code: "+237", label: "CM (+237)" },
    { code: "+238", label: "CV (+238)" },
    { code: "+239", label: "ST (+239)" },
    { code: "+240", label: "GQ (+240)" },
    { code: "+241", label: "GA (+241)" },
    { code: "+242", label: "CG (+242)" },
    { code: "+243", label: "CD (+243)" },
    { code: "+244", label: "AO (+244)" },
    { code: "+245", label: "GW (+245)" },
    { code: "+248", label: "SC (+248)" },
    { code: "+249", label: "SD (+249)" },
    { code: "+250", label: "RW (+250)" },
    { code: "+251", label: "ET (+251)" },
    { code: "+252", label: "SO (+252)" },
    { code: "+253", label: "DJ (+253)" },
    { code: "+254", label: "KE (+254)" },
    { code: "+255", label: "TZ (+255)" },
    { code: "+256", label: "UG (+256)" },
    { code: "+257", label: "BI (+257)" },
    { code: "+258", label: "MZ (+258)" },
    { code: "+260", label: "ZM (+260)" },
    { code: "+261", label: "MG (+261)" },
    { code: "+262", label: "RE (+262)" },
    { code: "+263", label: "ZW (+263)" },
    { code: "+264", label: "NA (+264)" },
    { code: "+265", label: "MW (+265)" },
    { code: "+266", label: "LS (+266)" },
    { code: "+267", label: "BW (+267)" },
    { code: "+268", label: "SZ (+268)" },
    { code: "+269", label: "KM (+269)" },
    { code: "+290", label: "SH (+290)" },
    { code: "+291", label: "ER (+291)" },
    { code: "+297", label: "AW (+297)" },
    { code: "+298", label: "FO (+298)" },
    { code: "+299", label: "GL (+299)" },
    { code: "+350", label: "GI (+350)" },
    { code: "+351", label: "PT (+351)" },
    { code: "+352", label: "LU (+352)" },
    { code: "+353", label: "IE (+353)" },
    { code: "+354", label: "IS (+354)" },
    { code: "+355", label: "AL (+355)" },
    { code: "+356", label: "MT (+356)" },
    { code: "+357", label: "CY (+357)" },
    { code: "+358", label: "FI (+358)" },
    { code: "+359", label: "BG (+359)" },
    { code: "+370", label: "LT (+370)" },
    { code: "+371", label: "LV (+371)" },
    { code: "+372", label: "EE (+372)" },
    { code: "+373", label: "MD (+373)" },
    { code: "+374", label: "AM (+374)" },
    { code: "+375", label: "BY (+375)" },
    { code: "+376", label: "AD (+376)" },
    { code: "+377", label: "MC (+377)" },
    { code: "+378", label: "SM (+378)" },
    { code: "+380", label: "UA (+380)" },
    { code: "+381", label: "RS (+381)" },
    { code: "+382", label: "ME (+382)" },
    { code: "+385", label: "HR (+385)" },
    { code: "+386", label: "SI (+386)" },
    { code: "+387", label: "BA (+387)" },
    { code: "+389", label: "MK (+389)" },
    { code: "+420", label: "CZ (+420)" },
    { code: "+421", label: "SK (+421)" },
    { code: "+423", label: "LI (+423)" },
    { code: "+500", label: "FK (+500)" },
    { code: "+501", label: "BZ (+501)" },
    { code: "+502", label: "GT (+502)" },
    { code: "+503", label: "SV (+503)" },
    { code: "+504", label: "HN (+504)" },
    { code: "+505", label: "NI (+505)" },
    { code: "+506", label: "CR (+506)" },
    { code: "+507", label: "PA (+507)" },
    { code: "+509", label: "HT (+509)" },
    { code: "+590", label: "GP (+590)" },
    { code: "+591", label: "BO (+591)" },
    { code: "+592", label: "GY (+592)" },
    { code: "+593", label: "EC (+593)" },
    { code: "+594", label: "GF (+594)" },
    { code: "+595", label: "PY (+595)" },
    { code: "+596", label: "MQ (+596)" },
    { code: "+597", label: "SR (+597)" },
    { code: "+598", label: "UY (+598)" },
    { code: "+599", label: "CW (+599)" },
    { code: "+670", label: "TL (+670)" },
    { code: "+672", label: "NF (+672)" },
    { code: "+673", label: "BN (+673)" },
    { code: "+674", label: "NR (+674)" },
    { code: "+675", label: "PG (+675)" },
    { code: "+676", label: "TO (+676)" },
    { code: "+677", label: "SB (+677)" },
    { code: "+678", label: "VU (+678)" },
    { code: "+679", label: "FJ (+679)" },
    { code: "+680", label: "PW (+680)" },
    { code: "+681", label: "WF (+681)" },
    { code: "+682", label: "CK (+682)" },
    { code: "+683", label: "NU (+683)" },
    { code: "+685", label: "WS (+685)" },
    { code: "+686", label: "KI (+686)" },
    { code: "+687", label: "NC (+687)" },
    { code: "+688", label: "TV (+688)" },
    { code: "+689", label: "PF (+689)" },
    { code: "+690", label: "TK (+690)" },
    { code: "+691", label: "FM (+691)" },
    { code: "+692", label: "MH (+692)" },
    { code: "+850", label: "KP (+850)" },
    { code: "+852", label: "HK (+852)" },
    { code: "+853", label: "MO (+853)" },
    { code: "+855", label: "KH (+855)" },
    { code: "+856", label: "LA (+856)" },
    { code: "+880", label: "BD (+880)" },
    { code: "+886", label: "TW (+886)" },
    { code: "+960", label: "MV (+960)" },
    { code: "+961", label: "LB (+961)" },
    { code: "+962", label: "JO (+962)" },
    { code: "+963", label: "SY (+963)" },
    { code: "+964", label: "IQ (+964)" },
    { code: "+965", label: "KW (+965)" },
    { code: "+966", label: "SA (+966)" },
    { code: "+967", label: "YE (+967)" },
    { code: "+968", label: "OM (+968)" },
    { code: "+970", label: "PS (+970)" },
    { code: "+971", label: "AE (+971)" },
    { code: "+972", label: "IL (+972)" },
    { code: "+973", label: "BH (+973)" },
    { code: "+974", label: "QA (+974)" },
    { code: "+975", label: "BT (+975)" },
    { code: "+976", label: "MN (+976)" },
    { code: "+977", label: "NP (+977)" },
    { code: "+992", label: "TJ (+992)" },
    { code: "+993", label: "TM (+993)" },
    { code: "+994", label: "AZ (+994)" },
    { code: "+995", label: "GE (+995)" },
    { code: "+996", label: "KG (+996)" },
    { code: "+998", label: "UZ (+998)" },
  ];
  const [showOtpOption, setShowOtpOption] = useState(false);
  const [otpView, setOtpView] = useState(false);
  // OTP local state (can't use usePhoneOTP hook because its send/verify endpoints require auth)
  const [otpCode, setOtpCode] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otpLoading, setOtpLoading] = useState(false);
  const [otpError, setOtpError] = useState("");
  const [otpTimer, setOtpTimer] = useState(0);

  const navigate = useNavigate();
  const location = useLocation();
  const { login: contextLogin } = useContext(AuthContext);

  const passwordRef = useRef(null);

  // OTP Timer countdown
  useEffect(() => {
    if (otpTimer <= 0) return;
    const interval = setInterval(() => setOtpTimer((t) => t - 1), 1000);
    return () => clearInterval(interval);
  }, [otpTimer]);

  // Auto-focus password field when it appears
  useEffect(() => {
    if (step === "PASSWORD" && passwordRef.current) {
      const timer = setTimeout(() => {
        passwordRef.current?.focus();
      }, 50);
      return () => clearTimeout(timer);
    }
  }, [step]);

  const resetOTPState = () => {
    setOtpCode("");
    setOtpSent(false);
    setOtpLoading(false);
    setOtpError("");
    setOtpTimer(0);
    setOtpView(false);
  };

  const buildLoginPayload = (value) => {
    const userLocation = localStorage.getItem("user_location")
      ? JSON.parse(localStorage.getItem("user_location"))
      : {};

    const isEmail = value.includes("@");

    let finalUsername = value;
    let email = isEmail ? value : "";
    let mobile = "";
    let cc = "";

    if (!isEmail) {
      // Remove the country code prefix from the cleaned number if it starts with the digits
      // e.g. if countryCode is "+91" and value is "919582191882", strip the leading "91"
      const ccDigits = countryCode.replace(/\D/g, "");
      let stripped = value;
      if (ccDigits && stripped.startsWith(ccDigits)) {
        stripped = stripped.slice(ccDigits.length);
      }
      stripped = stripped.replace(/\D/g, "");

      if (stripped) {
        finalUsername = `${countryCode}${stripped}`;
        mobile = stripped;
        cc = countryCode;
      }
    }

    return {
      username: finalUsername,
      email,
      mobile,
      countryCode: cc,
      loginLocation: {
        city: userLocation.city || "Unknown City",
        state: userLocation.state || "Unknown State",
        country: userLocation.country || "Unknown Country",
        fullAddress: userLocation.full_address || "Unknown Address",
      },
    };
  };

  const handleLogin = async (e) => {
    if (e) e.preventDefault();

    if (!input.trim()) {
      setInputError("Enter email or mobile number");
      return;
    }

    let normalizedInput = input.trim();

    if (step === "IDENTIFIER") {
      const isEmail = normalizedInput.includes("@");

      if (isEmail) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(normalizedInput)) {
          setInputError("Enter a valid email address or mobile number");
          return;
        }
        normalizedInput = normalizedInput.toLowerCase();
      } else {
        // Reject if input contains non-digit chars
        const digitsOnly = normalizedInput.replace(/^\+/, "");
        if (!/^\d+$/.test(digitsOnly)) {
          setInputError("Enter a valid mobile number");
          return;
        }
        const cleaned = normalizedInput.replace(/\D/g, "");

        // Basic validation: 4-15 digits (covers most international numbers)
        if (cleaned.length < 4 || cleaned.length > 15) {
          setInputError("Enter a valid mobile number");
          return;
        }
        normalizedInput = cleaned;
      }
      setInputError("");
    }

    try {
      if (step === "PASSWORD") {
        const res = await api.post("/auth/verify-password", {
          username: buildLoginPayload(input).username,
          password,
        });

        // Store access token in localStorage for API calls
        // Refresh token is stored in HTTP-only cookie automatically by backend
        if (res.data.token) {
          localStorage.setItem("token", res.data.token);
        }
        // Use AuthContext to save complete user object from API response
        contextLogin(
          res.data.user,
          res.data.user?.role === "vendor" ? res.data.vendorProfile : null,
          res.data.user?.role === "agent" ? res.data.agentProfile : null,
          res.data.token
        );
        // Subscribe this device to push notifications
        subscribeToPush();
        navigate(location.state?.redirectTo || "/");
        return;
      }

      const loginPayload = buildLoginPayload(normalizedInput);
      const res = await api.post("/auth/login", loginPayload);

      if (res.data.requiresPassword) {
        setStep("PASSWORD");
        // Show OTP option only for phone numbers (not email)
        if (!normalizedInput.includes("@")) {
          setShowOtpOption(true);
        }
        return;
      }

      if (res.data.requiresPasswordSetup) {
        const user = res.data.user;
        user.isRegistration = true;
        // Store access token in localStorage (refresh token in cookie)
        if (res.data.token) {
          localStorage.setItem("token", res.data.token);
        }
        // Use AuthContext to save complete user object for registration
        contextLogin(user, null, null, res.data.token);
        navigate(`/register/${user.role}`);
        return;
      }

      const user = res.data.user;
      if (res.data.token) {
        try {
          const payload = JSON.parse(atob(res.data.token.split('.')[1]));
          if (payload.registration) user.isRegistration = true;
        } catch (e) { console.error("Failed to decode token:", e.message); }
      }
      // Store access token in localStorage (refresh token in cookie)
      if (res.data.token) {
        localStorage.setItem("token", res.data.token);
      }
      // Use AuthContext to save complete user object
      contextLogin(user, null, null, res.data.token);
      // Subscribe this device to push notifications
      subscribeToPush();
      navigate("/");
    } catch (err) {
      if (err.response?.status === 400) {
        setOpenRolePopup(true);
      } else {
        alert("Login failed. Try again.");
      }
    }
  };

  const selectRole = async (role) => {
    try {
      const res = await api.post("/auth/login", {
        ...buildLoginPayload(input.trim()),
        role,
      });

      const userData = res.data.user;
      if (res.data.isNewUser || res.data.requiresPasswordSetup) userData.isRegistration = true;

      // Store access token in localStorage (refresh token in cookie)
      if (res.data.token) {
        localStorage.setItem("token", res.data.token);
      }
      // Use AuthContext to save complete user object
      contextLogin(userData, null, null, res.data.token);
      setOpenRolePopup(false);
      navigate(`/register/${role}`);
    } catch (err) {
      alert("Registration failed");
    }
  };

  /* ── OTP Handlers ── */
  const handleSendLoginOTP = async () => {
    const phone = buildLoginPayload(input).username;
    setOtpView(true);
    try {
      setOtpLoading(true);
      setOtpError("");
      const res = await api.post("/auth/send-login-otp", {
        phoneNumber: phone,
      });
      if (res.data.success) {
        setOtpSent(true);
        setOtpTimer(30);
      }
    } catch (err) {
      const msg = err.response?.data?.message || "Failed to send OTP";
      setOtpError(msg);
    } finally {
      setOtpLoading(false);
    }
  };

  const handleVerifyLoginOTP = async () => {
    const phone = buildLoginPayload(input).username;
    if (!otpCode || otpCode.length < 4) {
      setOtpError("Enter a valid OTP");
      return;
    }
    try {
      setOtpLoading(true);
      setOtpError("");
      const res = await api.post("/auth/verify-login-otp", {
        phoneNumber: phone,
        otpCode: otpCode,
      });
      if (res.data.success) {
        contextLogin(
          res.data.user,
          res.data.user?.role === "vendor" ? res.data.vendorProfile : null,
          res.data.user?.role === "agent" ? res.data.agentProfile : null
        );
        // Store access token in localStorage (refresh token in cookie)
        if (res.data.token) {
          localStorage.setItem("token", res.data.token);
        }
        // Refresh token is stored as an HTTP-only cookie by the backend.
        // Subscribe this device to push notifications
        subscribeToPush();
        navigate(location.state?.redirectTo || "/");
      }
    } catch (err) {
      setOtpError(err.response?.data?.message || "Invalid OTP");
    } finally {
      setOtpLoading(false);
    }
  };

  return (
    <Box sx={{ height: "100dvh", display: "flex", alignItems: "flex-start", justifyContent: "center", backgroundColor: "#f3f3f3", pt: 6, overflow: "hidden" }}>
      <Paper elevation={3} sx={{ p: 2.5, width: 400, borderRadius: 2 }}>
        <Typography variant="h6" sx={{ fontWeight: 500 }}>Sign in</Typography>

        <Box component="form" onSubmit={handleLogin} sx={{ width: "100%" }}>
          <TextField
            fullWidth
            label="Mobile number or Email"
            value={input}
            onChange={(e) => {
              const val = e.target.value.toLowerCase();
              // Auto-detect country code from first digit if user is typing digits
              if (val && !val.includes("@")) {
                const firstDigit = val.replace(/\D/g, "")[0];
                if (firstDigit === "1") setCountryCode("+86");
                else if (/^[6-9]$/.test(firstDigit)) setCountryCode("+91");
                else if (firstDigit === "0") setCountryCode("+44");
              }
              setInput(val);
              setInputError("");
              if (step === "PASSWORD") { setStep("IDENTIFIER"); setPassword(""); setShowOtpOption(false); resetOTPState(); }
            }}
            InputProps={{
              startAdornment: /^\+?\d+$/.test(input) ? (
                <InputAdornment position="start">
                  <Select
                    value={countryCode}
                    onChange={(e) => setCountryCode(e.target.value)}
                    sx={{
                      fontSize: 14,
                      height: 32,
                      "& .MuiSelect-select": { py: 0, pr: 2 },
                      "& fieldset": { border: "none" },
                    }}
                  >
                    {countryCodes.map((cc) => (
                      <MenuItem key={cc.code} value={cc.code}>{cc.label}</MenuItem>
                    ))}
                  </Select>
                </InputAdornment>
              ) : undefined,
            }}
            inputProps={{ style: { textTransform: "lowercase" } }}
            error={!!inputError}
            helperText={inputError}
            sx={{ mb: 2 }}
          />

          {step === "PASSWORD" && !otpView && (
            <>
              <TextField
                fullWidth label="Password" type="password" value={password}
                onChange={(e) => setPassword(e.target.value)} sx={{ mb: 1 }}
                inputRef={passwordRef}
                onKeyDown={(e) => { if (e.key === "Enter") handleLogin(e); }}
              />
              <Typography sx={{ color: "#0066c0", cursor: "pointer", fontSize: 13, mb: 2 }}
                onClick={() => navigate("/forgot-password", { state: { username: input } })}>
                Forgot Password?
              </Typography>
              {showOtpOption && (
                <Button fullWidth variant="outlined"
                  sx={{ textTransform: "none", mb: 2, borderRadius: "20px", py: 1 }}
                  onClick={handleSendLoginOTP}
                  disabled={otpLoading}>
                  Login with OTP
                </Button>
              )}
              <Button type="submit" variant="contained" fullWidth
                sx={{ backgroundColor: "#ff9900", color: "#fff", textTransform: "none", fontWeight: 600, borderRadius: "20px", py: 1, "&:hover": { backgroundColor: "#ff8800" } }}>
                Sign in
              </Button>
            </>
          )}

          {step === "PASSWORD" && otpView && (
            <>
              <Typography variant="body2" sx={{ mb: 1, color: "#f57c00", fontWeight: 500 }}>
                {otpSent ? "OTP sent to your WhatsApp" : "Sending OTP..."}
              </Typography>
              <TextField
                fullWidth label="Enter OTP" value={otpCode}
                onChange={(e) => setOtpCode(e.target.value.replace(/\D/g, "").slice(0, 4))}
                sx={{ mb: 1 }}
                placeholder="4-digit OTP"
                error={!!otpError}
                helperText={otpError}
              />
              <Button fullWidth variant="contained"
                sx={{ backgroundColor: "#ff9900", color: "#fff", textTransform: "none", fontWeight: 600, borderRadius: "20px", py: 1, "&:hover": { backgroundColor: "#ff8800" } }}
                onClick={handleVerifyLoginOTP}
                disabled={otpLoading || otpCode.length < 4}>
                Verify OTP
              </Button>
              <Typography sx={{ color: "#0066c0", cursor: "pointer", fontSize: 13, mt: 1, textAlign: "center" }}
                onClick={otpTimer > 0 ? undefined : handleSendLoginOTP}>
                {otpTimer > 0 ? `Resend OTP in ${otpTimer}s` : "Resend OTP"}
              </Typography>
              <Typography sx={{ color: "#666", cursor: "pointer", fontSize: 13, mt: 0.5, textAlign: "center" }}
                onClick={() => { setOtpView(false); resetOTPState(); }}>
                Back to Password
              </Typography>
            </>
          )}

          {step !== "PASSWORD" && (
            <Button type="submit" variant="contained" fullWidth
              sx={{ backgroundColor: "#ff9900", color: "#fff", textTransform: "none", fontWeight: 600, borderRadius: "20px", py: 1, "&:hover": { backgroundColor: "#ff8800" } }}>
              Continue
            </Button>
          )}
        </Box>

        <Typography variant="caption" sx={{ display: "block", mt: 1.2, color: "text.secondary", lineHeight: 1.4 }}>
          By continuing, you agree to our{" "}
          <Box component="span" sx={{ color: "#0066c0", cursor: "pointer" }}>Terms of Use</Box> and{" "}
          <Box component="span" sx={{ color: "#0066c0", cursor: "pointer" }}>Privacy Policy</Box>.
        </Typography>
      </Paper>

      <Dialog open={openRolePopup} onClose={() => setOpenRolePopup(false)}>
        <IconButton onClick={() => setOpenRolePopup(false)} sx={{ position: "absolute", top: 8, right: 8 }}><CloseIcon /></IconButton>
        <DialogTitle>Select Your Role</DialogTitle>
        <DialogContent><Typography>Please choose how you want to continue:</Typography></DialogContent>
        <DialogActions sx={{ flexDirection: "column", p: 2 }}>
          {["customer", "vendor", "agent"].map((r) => (
            <Button key={r} fullWidth variant="contained" onClick={() => selectRole(r)}
              sx={{ mt: 1, backgroundColor: "#ff9900", color: "#fff", textTransform: "none", fontWeight: 600, borderRadius: "20px", "&:hover": { backgroundColor: "#ff8800" } }}>
              I am a {r}
            </Button>
          ))}
        </DialogActions>
      </Dialog>
    </Box>
  );
}